import { useNavigate } from "react-router";
import { Mail, Phone, MapPin, Building2 } from "lucide-react";
import { PortalLayout } from "../components/PortalLayout";

export function ManagementContactPage() {
  const navigate = useNavigate();

  return (
    <PortalLayout>

      {/* Header */}
      <div className="mb-14">
        <p className="text-xs font-semibold uppercase tracking-widest text-[#7B1A1A] mb-4">
          Management Contact
        </p>
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-semibold text-[#1F2933] mb-8 leading-tight max-w-3xl">
          Authorised Stakeholder Contact
        </h1>
        <p className="text-[#4B5563] max-w-3xl leading-relaxed">
          For authorised stakeholder inquiries, strategic partnership discussions, or infrastructure service
          information, please use the contact details provided below.
        </p>
      </div>

      {/* Contact Grid */}
      <div className="grid md:grid-cols-2 gap-8 mb-14">

        <div className="bg-white border border-[#E5E7EB] rounded-lg p-8 shadow-sm">
          <Building2 className="w-8 h-8 text-[#7B1A1A] mb-4" />
          <h2 className="text-xl font-semibold text-[#1F2933] mb-6">LEO Group</h2>
          <div className="space-y-5">
            <div className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-[#7B1A1A] mt-1 flex-shrink-0" />
              <div>
                <p className="text-xs text-[#4B5563] mb-1">Email</p>
                <p className="text-sm text-[#1F2933]">contact@leogroup.com</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-[#7B1A1A] mt-1 flex-shrink-0" />
              <div>
                <p className="text-xs text-[#4B5563] mb-1">Phone</p>
                <p className="text-sm text-[#1F2933]">Available upon request</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#7B1A1A] mt-1 flex-shrink-0" />
              <div>
                <p className="text-xs text-[#4B5563] mb-1">Location</p>
                <p className="text-sm text-[#1F2933]">Information available to authorised stakeholders</p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-[#FDEAE0]/60 border border-[#7B1A1A]/15 rounded-lg p-6">
            <h3 className="text-sm font-semibold text-[#1F2933] mb-2">Authorised Access Only</h3>
            <p className="text-sm text-[#4B5563] leading-relaxed">
              All inquiries are subject to verification. Detailed operational and strategic information is
              available exclusively to authorised stakeholders within the secure portal.
            </p>
          </div>

          <div className="bg-white border border-[#E5E7EB] rounded-lg p-6 shadow-sm">
            <h3 className="text-sm font-semibold text-[#1F2933] mb-3">Infrastructure Services</h3>
            <p className="text-sm text-[#4B5563] leading-relaxed mb-4">
              For inquiries regarding enterprise infrastructure hosting, disaster recovery, and data services,
              please contact us through the secure portal or email contact@leogroup.com.
            </p>
            <button
              onClick={() => navigate("/infrastructure")}
              className="text-xs font-medium text-[#7B1A1A] hover:text-[#6b1515] transition-colors"
            >
              View Infrastructure Services →
            </button>
          </div>
        </div>
      </div>

      {/* Security Notice */}
      <div className="bg-white border border-[#E5E7EB] rounded-lg p-6 shadow-sm mb-14 text-center">
        <p className="text-sm text-[#4B5563] leading-relaxed">
          This portal session is monitored and time-restricted in accordance with LEO Group's information security
          protocols. All communications are subject to confidentiality obligations.
        </p>
      </div>


    </PortalLayout>
  );
}
